import React from 'react';
import { registerClass, classNames } from '@food/css-manager';
var style = registerClass(function (theme) { return "\n\tcolor: " + theme.colors.danger.plain + ";\n"; });
export var ErrorMessage = function (_a) {
    var className = _a.className, error = _a.error;
    return (React.createElement("div", { className: classNames(className, style) },
        React.createElement("div", { dangerouslySetInnerHTML: { __html: error } })));
};
//# sourceMappingURL=ErrorMessage.js.map